// Fulfillment Status Map
const production_order_statuses = {
    scheduled: {
        label: 'Programmé',
        badgeColor: 'orange',
    },
    open: {
        label: 'En cours',
        badgeColor: 'blue',
    },
    closed: {
        label: 'Terminé',
        badgeColor: 'green',
    },
    cancelled: {
        label: 'Annulé',
        badgeColor: 'red',
    },
}

export default function statuses(production_order) {
    const unknown = {
        label: 'Inconnu',
        badgeColor: 'gray',
    }

    const status =
        production_order_statuses[production_order?.status] ?? unknown

    return status
}
